import React from 'react';

import { useExportTemplate, useStatusTemplates } from 'Templates';

import {
  Action,
  Actions,
  DescriptionIcon,
  ActionBar,
} from '@gogame/components';
import {
  APPS_FLYER_PROVIDER,
  MY_TRACKER_PROVIDER,
} from 'scenes/Influencers/MasterCampaigns/constants';
import { FullScreenToggler } from '@gogame/data-grid';

import { SearchField, useScreenTitle } from '@gogame/screens';

import { TEMPLATE_NEW_MASTER_CAMPAIGN } from 'scenes/Influencers/MasterCampaigns/constants';

export default ({ onCreate: handleCreate }) => {
  const [screenTitle] = useScreenTitle();

  const templateUpdated = useStatusTemplates({
    name: TEMPLATE_NEW_MASTER_CAMPAIGN,
  });
  const [exportMasterCampaignTemplate] = useExportTemplate({
    name: TEMPLATE_NEW_MASTER_CAMPAIGN,
  });
  const handleExportMasterCampaignTemplate = async () => {
    await exportMasterCampaignTemplate();
  };

  return (
    <ActionBar
      title={screenTitle}
      search={<SearchField tooltip={'Search by name or id'} />}
      secondaryActions={
        <Actions>
          <Action
            icon={<DescriptionIcon />}
            onClick={handleExportMasterCampaignTemplate}
            label={`Download template${templateUpdated ? ' (Updated)' : ''}`}
            badge={templateUpdated}
          />
          <Action component={FullScreenToggler} />
        </Actions>
      }
      primaryActions={
        <Actions>
          <Action
            border={true}
            button={true}
            add={true}
            iconContent={true}
            tooltip={'Add Master Campaign'}
            variant={'outlined'}
          >
            <Action
              label={'AppsFlyer attr provider'}
              onClick={() => handleCreate(APPS_FLYER_PROVIDER)}
            />
            <Action
              label={'MyTracker attr provider'}
              onClick={() => handleCreate(MY_TRACKER_PROVIDER)}
            />
          </Action>
        </Actions>
      }
    />
  );
};
